import { Component, computed, inject, input, Input, InputSignal, Signal } from '@angular/core';
import {
  ApplicationAppEntityApplicationRead,
  ShipmentAppEntityShipmentRead
} from '../../../../../openapi';
import {
  AgreementsDataPreviewComponent
} from '../../common/agreements-data-section/components/agreements-data-preview/agreements-data-preview.component';
import {
  ApplicantPreviewComponent
} from '../../common/applicant-data-section/components/applicant-preview/applicant-preview.component';
import {
  ApplicationDataPreviewComponent
} from '../../common/application-data-section/components/application-data-preview/application-data-preview.component';
import {
  AttachmentsDataPreviewComponent
} from '../../common/attachments-data-section/components/attachments-data-preview/attachments-data-preview.component';
import { CommonModule, DatePipe } from '@angular/common';
import { DecisionDataPreviewComponent } from '../../common/decision-data-preview/decision-data-preview.component';
import { LabelComponent } from '../../../../../common/label/label.component';
import {
  ContractorDataPreviewComponent
} from '../../common/contractor-data-section/components/contractor-data-preview/contractor-data-preview.component';
import {
  OccupationOfLanePlacementConstructionObjectsFormValue, occupationsToFormValue
} from '../sections/occupation-of-lane-placement-construction-objects-section/forms/occupation-of-lane-placement-construction-objects.form';
import {
  OccupationOfLanePlacementConstructionObjectsPreviewComponent
} from '../sections/occupation-of-lane-placement-construction-objects-section/components/occupation-of-lane-placement-construction-objects-preview/occupation-of-lane-placement-construction-objects-preview.component';
import {
  PaymentsDataPreviewComponent
} from '../../common/payments-data-section/components/payments-data-preview/payments-data-preview.component';
import { ApplicationPayment } from '../../../../../services/application.common.model';
import { selectPayment } from '../../../../../store/selectors/application.selectors';
import { Store } from '@ngrx/store';

@Component({
  selector: 'app-occupation-data-of-lane-placement-construction-objects-preview',
  standalone: true,
  imports: [
    AgreementsDataPreviewComponent,
    ApplicantPreviewComponent,
    ApplicationDataPreviewComponent,
    AttachmentsDataPreviewComponent,
    DatePipe,
    DecisionDataPreviewComponent,
    LabelComponent,
    CommonModule,
    ContractorDataPreviewComponent,
    OccupationOfLanePlacementConstructionObjectsPreviewComponent,
    PaymentsDataPreviewComponent
  ],
  templateUrl: './occupation-data-of-lane-placement-construction-objects-preview.component.html'
})
export class OccupationDataOfLanePlacementConstructionObjectsPreviewComponent {

  private store$: Store = inject(Store);

  @Input()
  public expanded: boolean = true;

  public application: InputSignal<ApplicationAppEntityApplicationRead | null> = input<ApplicationAppEntityApplicationRead | null>(null);

  public shipments: InputSignal<ShipmentAppEntityShipmentRead[]> = input<ShipmentAppEntityShipmentRead[]>([]);

  public roadOccupation: Signal<OccupationOfLanePlacementConstructionObjectsFormValue | null> = computed(() => occupationsToFormValue(this.application()?.roadOccupations || []).at(0) || null);

  public payment: Signal<ApplicationPayment | null> = this.store$.selectSignal(selectPayment);

  public canPay: InputSignal<boolean> = input<boolean>(false);
}
